import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSiteInfo } from "../../contexts/SiteInfoContext";
import { FaFacebookF, FaYoutube, FaTiktok, FaPhone, FaEnvelope, FaMapMarkerAlt, FaRegCopyright } from "react-icons/fa";
import {  PiPhone } from "react-icons/pi";
import { SiZalo } from "react-icons/si";
import ThemeSwitcher from "./ThemeSwitcher"; // Đã tách riêng

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { siteInfo, loading } = useSiteInfo();
  const [theme, setTheme] = useState(localStorage.getItem("site-theme") || "");

  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem("site-theme", theme);
  }, [theme]);

  if (loading || !siteInfo) return null;
  const lang = i18n.language;
  const socials = siteInfo.socials || {};

  return (
    <footer className="bg-card border-t border-primary/30 text-text pt-16 pb-8 px-4 mt-12 shadow-inner">
      <div className="max-w-6xl mx-auto grid gap-8 grid-cols-1 md:grid-cols-3 text-[15px]">
        {/* Cột 1: Thông tin */}
        <div>
          <h3 className="font-extrabold text-xl mb-3 text-primary tracking-wide flex items-center gap-2">
            {siteInfo.name?.[lang]}
          </h3>
          <p className="mb-1 flex items-center gap-2">
            <FaMapMarkerAlt className="inline-block text-primary w-4 h-4" />
            {siteInfo.address?.[lang]}
          </p>
          <p className="mb-1 flex items-center gap-2">
            <FaPhone className="inline-block text-secondary w-4 h-4" />
            <span className="font-semibold">{t("footer.hotline")}:</span> 
            <span className="text-secondary font-semibold">{siteInfo.hotline}</span>
          </p>
          <p className="flex items-center gap-2">
            <FaEnvelope className="inline-block text-primary w-4 h-4" />
            <span className="font-semibold">{t("footer.email")}:</span> 
            <span className="text-primary font-semibold">{siteInfo.email}</span>
          </p>
        </div>
        {/* Cột 2: Mạng xã hội */}
        <div>
          <h4 className="font-bold text-lg mb-2 text-primary flex items-center gap-2">
            <FaRegCopyright className="text-primary w-4 h-4" />
            {t("footer.followUs")}
          </h4>
          <ul className="flex gap-4 mt-1">
            {socials.facebook && (
              <li>
                <a
                  href={socials.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary/10 hover:bg-primary text-primary hover:text-white rounded-full p-2 transition shadow hover:shadow-lg"
                  aria-label="Facebook"
                >
                  <FaFacebookF className="w-5 h-5" />
                </a>
              </li>
            )}
            {socials.youtube && (
              <li>
                <a
                  href={socials.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary/10 hover:bg-secondary text-primary hover:text-menu rounded-full p-2 transition shadow hover:shadow-lg"
                  aria-label="YouTube"
                >
                  <FaYoutube className="w-5 h-5" />
                </a>
              </li>
            )}
            {socials.tiktok && (
              <li>
                <a
                  href={socials.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary/10 hover:bg-secondary text-primary hover:text-menu rounded-full p-2 transition shadow hover:shadow-lg"
                  aria-label="TikTok"
                >
                  <FaTiktok className="w-5 h-5" />
                </a>
              </li>
            )}
          </ul>
        </div>
        {/* Cột 3: Liên hệ nhanh & đổi theme */}
        <div>
          <h4 className="font-bold text-lg mb-2 text-primary flex items-center gap-2">
            <PiPhone className="text-primary w-5 h-5" />
            {t("footer.contact")}
          </h4>
          {siteInfo.zalo && (
            <a
              href={siteInfo.zalo}
              target="_blank"
              rel="noopener noreferrer"
              className="block mb-1 text-primary font-bold hover:text-secondary transition flex items-center gap-2"
            >
              <SiZalo className="text-[#028fe7] w-5 h-5" />
              : {siteInfo.hotline}
            </a>
          )}
          {/* Đổi theme */}
          <div className="flex items-center gap-2 mt-2">
            <ThemeSwitcher
              theme={theme}
              setTheme={setTheme}
              label={t("footer.theme")}
            />
          </div>
        </div>
      </div>
      {/* Copyright */}
      <div className="mt-8 border-t border-primary/20 text-center text-xs text-text2 pt-4 tracking-wide flex items-center justify-center gap-2">
        <FaRegCopyright className="inline-block text-primary/80 w-4 h-4" />
        {new Date().getFullYear()} {siteInfo.name?.[lang] || "Quyenxd Class"}. {t("footer.copyright")}
      </div>
    </footer>
  );
};

export default Footer;
